import { ApplicationIdentifier } from '@tgg/common-types';

export const applicationIdentifier: ApplicationIdentifier = 'commerce' as const;
